import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../layout/service/user.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-sheet-user-answer',
    imports: [
        CommonModule,
        FormsModule
    ],
    template: `
<div class="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100 py-10 px-2">
    <div class="max-w-6xl mx-auto">
        <h2 class="text-3xl md:text-4xl font-extrabold text-blue-900 mb-8 text-center drop-shadow">Daftar Jawaban Siswa</h2>
        <div class="flex justify-center mb-8">
            <input
                type="text"
                [(ngModel)]="search"
                placeholder="Cari nama siswa..."
                class="w-full md:w-96 px-4 py-2 rounded-full border border-blue-200 shadow focus:outline-none focus:ring-2 focus:ring-blue-300 transition"
            />
        </div>
        <ng-container *ngIf="filteredForms.length > 0; else emptyCases">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div *ngFor="let form of filteredForms"
                    class="relative bg-white rounded-3xl shadow-2xl border border-blue-100 group overflow-hidden transition hover:shadow-blue-200 hover:border-blue-400 cursor-pointer">
                    <div class="relative z-10 p-6 flex flex-col h-full">
                        <div class="mb-3 flex items-center gap-2">
                            <span class="inline-flex items-center gap-2 bg-blue-100/80 text-blue-700 text-xs md:text-sm px-3 py-1 rounded-full font-semibold shadow border border-blue-200">
                                <i class="pi pi-calendar"></i>
                                {{ form.created_at | date:'dd MMM yyyy, HH:mm' }}
                            </span>
                        </div>
                        <h3 class="text-lg font-bold text-blue-900 flex items-center gap-2 mb-3 mt-0">
                            <i class="pi pi-user text-blue-400"></i> {{ form.user_fullname }}
                        </h3>
                        <div class="text-gray-700 mb-4">
                            <span
                                *ngIf="getScore(form) !== null; else belumDinilai"
                                class="inline-block ml-2 px-3 py-1 rounded-full bg-blue-100 text-blue-800 text-xs font-semibold"
                            >
                                {{ getScore(form) }}
                            </span>
                            <ng-template #belumDinilai>
                                <span class="inline-block ml-2 px-3 py-1 rounded-full bg-gray-200 text-gray-600 text-xs font-semibold">
                                    Belum dinilai
                                </span>
                            </ng-template>
                        </div>
                        <div class="mt-auto flex justify-end">
                            <button type="button"
                                class="text-blue-700 hover:text-blue-900 font-semibold flex items-center gap-1 focus:outline-none transition"
                                (click)="lihatJawaban(form)">
                                Lihat Jawaban <i class="pi pi-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #emptyCases>
            <div class="flex flex-col items-center justify-center py-24">
                <i class="pi pi-inbox text-6xl text-blue-200 mb-4"></i>
                <div class="text-xl text-blue-900 font-semibold mb-2">Belum ada jawaban siswa</div>
                <div class="text-gray-500">Jawaban siswa akan tampil di sini jika sudah tersedia.</div>
            </div>
        </ng-template>
    </div>
</div>
    `
})
export class SheetUserAnswer implements OnInit {
    forms: any[] = [];
    search: string = '';
    id: string | null = null;
    private intervalId: any = null;
    private lastIds: Set<any> = new Set();

    constructor(
        private userService: UserService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        const userStr = localStorage.getItem('user');
        if (userStr) {
            try {
                const user = JSON.parse(userStr);

            } catch (e) {

            }
        }
        this.id = this.route.snapshot.paramMap.get('id');
    }

    ngOnInit() {
        // Ambil dari localStorage jika ada
        const cachedForm = localStorage.getItem('sheet_user_answer_detail');
        if (cachedForm) {
            try {
                this.forms = [JSON.parse(cachedForm)];
                localStorage.removeItem('sheet_user_answer_detail');
                return;
            } catch (e) {
                localStorage.removeItem('sheet_user_answer_detail');
            }
        }
        this.fetchAnswers();
        this.intervalId = setInterval(() => this.fetchAnswers(), 60000);
    }

    ngOnDestroy() {
        if (this.intervalId) clearInterval(this.intervalId);
    }

    fetchAnswers() {
        this.userService.getSheetAnswer({sheet_case_id: this.id}).then((res: any) => {
            if (res.status) {
                // Cek data baru
                const newData = res.data.filter((item: any) => !this.lastIds.has(item.id));
                if (newData.length > 0) {
                    for (const item of newData) this.lastIds.add(item.id);
                    this.forms = [...newData, ...this.forms];
                }
                // Jika forms kosong (pertama kali), isi semua dan set lastIds
                if (this.forms.length === 0 && res.data.length > 0) {
                    this.forms = res.data;
                    this.lastIds = new Set(res.data.map((d: any) => d.id));
                }
            }
        }).catch(() => {});
    }

    lihatJawaban(form: any) {
        localStorage.setItem('sheet_user_answer_detail', JSON.stringify(form));
        this.router.navigate(['/app/osce/sheet/user/answer/detail', form.id]);
    }

    get filteredForms() {
        if (!this.search?.trim()) return this.forms;
        const s = this.search.trim().toLowerCase();
        return this.forms.filter(form =>
            (form.name && form.name.toLowerCase().includes(s)) ||
            (form.description && form.description.toLowerCase().includes(s)) ||
            (form.user_fullname && form.user_fullname.toLowerCase().includes(s))
        );
    }

    getScore(form: any): any {
        if (!form) return null;
        if (form.score !== null && form.score !== undefined) {
            return form.score;
        }
        if (form.skor !== null && form.skor !== undefined) {
            return form.skor;
        }
        if (form.SKOR !== null && form.SKOR !== undefined) {
            return form.SKOR;
        }
        return null;
    }
}
